<template>
  <LmDialog v-model="modalShow" title="New subscriptions settings">
    <template #toolbar-actions>
      <q-btn :disable="!tasks || !tasks.length" size="sm" label="Save" color="tertiary" @click="onSave" />
    </template>
    <template #content>
      <div class="wrapper">
        <span class="text-faded text-center">
          Set which tasks are applicable for newly created subscriptions. We will use these settings as default when you
          create new subscriptions.<br />
          You will still have the option to override the default during creation.
        </span>
        <template v-if="!tasks">
          <div class="loader">
            <q-spinner color="primary" size="2.5em" />
          </div>
        </template>

        <MilestoneTasks v-else :tasks="tasks" @updated="tasks = $event" />
      </div>
    </template>
  </LmDialog>
</template>

<script>
import * as apiTo from '@api/api-routes'
// Components
import LmDialog from '@/reusable/base-components/LmDialog/LmDialog'
import MilestoneTasks from '@/reusable/milestone-tasks/MilestoneTasks'

export default {
  components: {
    LmDialog,
    MilestoneTasks
  },

  props: {
    value: Boolean
  },

  data: () => ({
    tasks: null
  }),

  computed: {
    modalShow: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },

  created() {
    apiTo.newSubsSettingsApi('get').then(({ data }) => (this.tasks = data.result))
  },

  methods: {
    async onSave() {
      await apiTo.newSubsSettingsApi('put', this.tasks)
      this.modalShow = false
    }
  }
}
</script>

<style lang="stylus" scoped>
.dialog-card {
  width: 1200px;
  max-width: 1200px;
}

.wrapper {
  padding 20px
  display grid

  .loader {
    display flex
    justify-content center
    align-items center
  }
}
</style>
